import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { ISchoolListingItemProp } from './SchoolListingItemProp'
import { SchoolListingItem } from './SchoolListingItem'
import { SchoolDetailsSectionSubTitle } from '../../School/SchoolDetailsSectionTitle'
import { take } from '../../../lib/ramda'
import { Link } from '../../../components/Link'
import { showModal } from '../../../states/modals/actions'
import { ModalType } from '../../../states/modals/ModalType.constants'
import { AddSchoolListingItem } from './AddSchoolListingItem'

const StyledSchoolListingGroup = styled.div`
  width: 100%;
`

const SchoolListItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const SchoolListingItemHeader = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
`

const SchoolListingItemHeaderText = styled(SchoolDetailsSectionSubTitle)`
  flex: 1;
`

const SchoolListingItemHeaderRight = styled.div``

const SchoolListingItemViewAllLink = styled(Link)`
  margin-bottom: 1rem;
`

const MAX_LISTINGS = 5

interface ISchoolListingGroupProps {
  title: string
  schoolCoords: Array<number>
  listings: Array<ISchoolListingItemProp>
}

const SchoolListingGroup: React.FC<ISchoolListingGroupProps> = ({
  title,
  schoolCoords,
  listings,
}) => {
  const dispatch = useDispatch()
  if (!(listings && listings.length > 0)) {
    return null
  }
  const closestListings = take(MAX_LISTINGS, listings)
  const noOfListings = listings.length
  const isShowViewAll = noOfListings > MAX_LISTINGS
  return (
    <StyledSchoolListingGroup>
      <SchoolListingItemHeader>
        <SchoolListingItemHeaderText>{title}</SchoolListingItemHeaderText>
        <SchoolListingItemHeaderRight>
          {isShowViewAll && (
            <SchoolListingItemViewAllLink
              onClick={() =>
                dispatch(
                  showModal(ModalType.SCHOOL_LISTING_VIEW_ALL_MODAL, {
                    listings,
                    schoolCoords,
                    header: title,
                  })
                )
              }
            >
              {`View all (${noOfListings})`}
            </SchoolListingItemViewAllLink>
          )}
        </SchoolListingItemHeaderRight>
      </SchoolListingItemHeader>
      <SchoolListItemsContainer>
        {closestListings.map((l) => (
          <SchoolListingItem
            key={l.id}
            schoolCoords={schoolCoords}
            listing={l}
          />
        ))}
        <AddSchoolListingItem />
      </SchoolListItemsContainer>
    </StyledSchoolListingGroup>
  )
}

export { SchoolListingGroup }
